function NotFound() {
  return "NotFound Page";
}

export default NotFound;
